<template>
    <div class="min-h-[20px] relative overflow-hidden">
        <div 
            v-if="showPrevButton" 
            class="hide-grid-element z-50 w-[180px] h-full flex items-center absolute top-0 left-0 bg-gradient-to-l from-transparent to-[#F7F9FC]">
            <button 
                class="w-[48px] h-[48px] bg-[#399ADB] rounded-full flex justify-center items-center"
                @click="move(1, 494)">
                <img src="/images/campaigns/carousel-left-arrow.svg" />
            </button>
        </div>

        <div 
            class="hide-grid-element grid grid-flow-col justify-start gap-6 overflow-hidden transition-all duration-200 ease-out"
            ref="scrollableContainer"
        >
            <slot />
        </div>

        <div 
            class="hide-mobile-col flex flex-col gap-4 overflow-hidden min-h-[50px] relative" 
            ref="loadMoreContainer">
            <slot />

            <div 
                v-if="showLoadMoreButton" 
                class="show-more-container flex justify-center items-end absolute left-0 bottom-0">
                <button 
                    class="show-more-button px-6 py-2 flex items-center rounded-full z-40"
                    @click="showMore">
                    {{ $t('campaign_version_two.Show more') }}

                    <img 
                        src="/images/campaigns/version-two/show-more-arrow-icon.svg"
                        class="pl-1 pt-0.5"
                    />
                </button>
            </div>
        </div>

        <div 
            v-if="showNextButton" 
            class="hide-grid-element z-50 w-[180px] h-full flex justify-end items-center absolute top-0 right-0 bg-gradient-to-l from-[#F7F9FC] to-transparent">
            <button 
                class="w-[48px] h-[48px] bg-[#399ADB] rounded-full flex justify-center items-center" 
                @click="move(-1, 494)">
                <img src="/images/campaigns/carousel-right-arrow.svg" />
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showLoadMoreButton: false,
            showPrevButton: false,
            showNextButton: true,
        };
    },
    mounted() {
        this.setLoadMoreContainerInitialHeight();
    },
    methods: {
        setLoadMoreContainerInitialHeight() {
            const container = this.$refs.loadMoreContainer;
            const childCount = container.children.length;

            if (childCount === 0) {
                return;
            } 
            
            if (childCount === 1) {
                return;
            }

            const height = container.children[0].offsetHeight * 1.65

            container.style.height = height + 'px';

            this.showLoadMoreButton = true;
        },
        showMore() {
            const container = this.$refs.loadMoreContainer;

            container.style.height = 'auto'

            this.showLoadMoreButton = false;
        },
        move(direction, pixels) {
            const container = this.$refs.scrollableContainer;
            const childCount = container.children.length;

            const containerWidth = container.offsetWidth;
            const maxOffset = containerWidth - childCount * pixels;
            const currentOffset = parseFloat(container.style.marginLeft || 0);
            const newOffset = direction === -1 ? Math.max(maxOffset, Math.min(0, currentOffset + direction * pixels)) : 0;

            const isAtLeftEnd = newOffset === 0;
            const isAtRightEnd = newOffset === maxOffset;

            if (isAtRightEnd) {
                this.showNextButton = false;
                this.showPrevButton = true;

                container.style.marginLeft = `${maxOffset - pixels + 10}px`;
            } else if (isAtLeftEnd) {
                this.showNextButton = true;
                this.showPrevButton = false;

                container.style.marginLeft = '0px';
            } else {
                if (newOffset < 0) {
                    this.showPrevButton = true;
                }

                container.style.marginLeft = `${newOffset}px`;
            }
        },
    },
}
</script>

<style scoped>
.show-more-container {
    width: 100%;
    height: 200px;
    background: linear-gradient(to top, #F7F9FC, transparent);
}

.show-more-button {
    background-color: white;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #D8DEE8;
    color: #108FE5;
}

@media screen and (min-width: 1024px) {
    .hide-mobile-col {
        display: none;
    }

}

@media screen and (max-width: 1023px) {
    .hide-grid-element {
        display: none;
    }
}
</style>